// How Stripe's own fields are dressed, for the one place that still mounts
// them: the subscription page's legacy payment method modal
// (components/Payments, flag-off sessions only).
//
// Stripe renders its fields inside an iframe, so nothing in the app's
// stylesheets reaches them — the look has to be handed over as options. Three
// fields are Stripe's: the card number, the expiry and the security code. The
// rest of the form is the app's own, and is styled in paymentForm.scss like any
// other form in it.

const FONT_FAMILY = "Poppins, -apple-system, BlinkMacSystemFont, sans-serif";
const TEXT_COLOR = "#000000";
const DANGER_COLOR = "#ff4d4f";
const PLACEHOLDER_COLOR = "#bfbfbf";

/**
 * The options every <Elements> group in the app is created with. No client
 * secret: a card is collected and filed against the organization, which is a
 * payment method, not a payment — nothing is being confirmed here.
 *
 * Only the font: an appearance is what Stripe dresses the fields it lays out
 * itself in, and the three mounted here are dressed field by field instead
 * (below). The font has to be loaded into the iframes for them to be able to
 * set anything in it — it is the one the rest of the page is set in, see
 * public/index.html.
 */
export const STRIPE_ELEMENTS_OPTIONS = {
   fonts: [
      {
         cssSrc: "https://fonts.googleapis.com/css?family=Poppins:400,500,600"
      }
   ]
};

/**
 * The card fields. They are mounted one per box, so each carries the type it
 * is: a number, an expiry and a security code.
 */
export const CARD_ELEMENT_OPTIONS = {
   style: {
      base: {
         color: TEXT_COLOR,
         fontFamily: FONT_FAMILY,
         fontSize: "14px",
         fontSmoothing: "antialiased",
         "::placeholder": { color: PLACEHOLDER_COLOR }
      },
      invalid: {
         color: DANGER_COLOR,
         iconColor: DANGER_COLOR
      }
   }
};
